import { render } from "./DiscussionCommentForm.vue?vue&type=template&id=f6979322&scoped=true"
import script from "./DiscussionCommentForm.vue?vue&type=script&lang=js"
export * from "./DiscussionCommentForm.vue?vue&type=script&lang=js"

import "./DiscussionCommentForm.vue?vue&type=style&index=0&id=f6979322&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6979322"]])

export default __exports__